<form (submit)="submitForm(currentForm.form.valid)" #currentForm="ngForm" novalidate>
  <fieldset>
    <div class="form-group">
      <div class="row">
        <div class="col-sm-6">
          <label>Matter</label>
          <app-matter-search [matterId]="appointmentRequest.matter_id" [triggerOnChange]="true" [small_input]="false" (matter_id)="onMatterSelect($event)"></app-matter-search>
          <div class="alert alert-danger alert-padding-sm" [hidden]="!(!matter && formSubmitted)">A matter needs to be selected</div>
        </div>
        <div class="col-sm-6" *ngIf="matter">
          <label>Selected Matter</label>
          <h5>
            <a [href]="'/matters/' + appointmentRequest.matter_id">{{ matter.number }}</a
            >&nbsp;- {{ matter.name }}
          </h5>
        </div>
      </div>
    </div>
    <div class="form-group">
      <div class="row">
        <div class="col-sm-6">
          <label>Attendees</label>
          <div class="input-group">
            <select class="form-control" [(ngModel)]="selectedAttendee" name="selectedAttendee" [disabled]="!appointmentRequest.matter_id">
              <option *ngFor="let attendee of attendees" [ngClass]="{ 'bg-info text-white': !attendee.user }" [ngValue]="attendee">{{ attendee.label }}</option>
            </select>
            <div class="input-group-append">
              <button type="button" class="btn btn-default" (click)="addAttendee()" [disabled]="!appointmentRequest.matter_id">Add</button>
            </div>
          </div>
          <small class="form-text text-muted"> Select a matter to get attendees list </small>
        </div>
        <div class="col-sm-6">
          <label>Selected Attendees - {{ selectedAttendees.length }}<span class="text-danger" *ngIf="selectedAttendees.length < 1 && formSubmitted">&nbsp;Atleast one attendee is required</span></label>
          <p *ngFor="let attendee of selectedAttendees" class="bg-primary text-white" style="padding: 3px 5px 3px 5px">
            <span>{{ attendee.label }}</span>
            <button (click)="removeAttendee(attendee)" class="close" style="color: white !important; background: none !important; text-shadow: none !important; opacity: 1" type="button">&times;</button>
          </p>
        </div>
      </div>
    </div>
    <div class="form-group">
      <div class="row">
        <div class="col-sm-6">
          <label>Type</label>
          <select class="form-control" (change)="onEventTypeChange()" required [(ngModel)]="appointmentRequest.event_type_id" name="event_type_id" #event_type_id="ngModel">
            <option *ngFor="let eventType of formOptions.event_types" [value]="eventType.value">{{ eventType.label }}</option>
          </select>
          <div class="alert alert-danger alert-padding-sm" [hidden]="!fieldShowErrorMessage(event_type_id)">Type needs to be selected</div>
        </div>
      </div>
    </div>
    <div class="form-group" *ngIf="!formOptions.eventTypePhone">
      <div class="row">
        <div class="col-sm-6">
          <label>Location Person/Place</label>
          <app-contact-search [contactId]="contact_id" [small_input]="false" (contact_id)="onLocationContactSelect($event)"></app-contact-search>
          <div class="alert alert-danger alert-padding-sm" [hidden]="!(formSubmitted && !contact_id)">Location Person/Place needs to be selected</div>
        </div>
        <div class="col-sm-6">
          <label>Location Address</label>
          <select class="form-control" [disabled]="!contact_id" [(ngModel)]="appointmentRequest.location_id" name="location_id" #location_id="ngModel" required>
            <option *ngFor="let location of locations" [value]="location.value">{{ location.label }}</option>
          </select>
          <div class="alert alert-danger alert-padding-sm" [hidden]="!fieldShowErrorMessage(location_id)">Location needs to be selected</div>
          <small class="form-text text-muted" *ngIf="!contact_id"> Please select a location person/place to get a list of locations </small>
        </div>
      </div>
    </div>
    <div class="form-group">
      <div class="row">
        <div class="col-sm-6">
          <label>Length</label>
          <select class="form-control" [(ngModel)]="appointmentRequest.length" name="length" #length="ngModel" required>
            <option *ngFor="let length of formOptions.lengths" [value]="length.value">{{ length.label }}</option>
          </select>
          <div class="alert alert-danger alert-padding-sm" [hidden]="!fieldShowErrorMessage(length)">Length of the appointment needs to be selected</div>
        </div>
        <div class="col-sm-6">
          <label>How Soon</label>
          <select class="form-control" [(ngModel)]="appointmentRequest.how_soon" name="how_soon" #how_soon="ngModel" required>
            <option *ngFor="let how_soon of formOptions.how_soon" [value]="how_soon.value">{{ how_soon.label }}</option>
          </select>
          <div class="alert alert-danger alert-padding-sm" [hidden]="!fieldShowErrorMessage(how_soon)">How soon the appointment is required, needs to be selected</div>
        </div>
      </div>
    </div>
    <div class="form-group">
      <label>Notes</label>
      <textarea class="form-control" [(ngModel)]="appointmentRequest.pre_notes" name="pre_notes"></textarea>
    </div>
    <div class="form-group has-error" *ngIf="(!currentForm.form.valid || !additionalValidations()) && formSubmitted" style="border-top: 1px solid #ccc">
      <span class="help-block"> Some errors were found in the form, please check again. </span>
    </div>
    <div class="form-group text-center">
      <button type="submit" class="btn btn-primary" [disabled]="formSubmitting">{{ appointmentRequest.id ? 'Update' : 'Create' }}</button>
      &nbsp;&nbsp;&nbsp;
      <app-button-back [buttonDisabled]="formSubmitting"></app-button-back>
    </div>
  </fieldset>
</form>
